import {Action} from '@ngrx/store';
import {Group} from '../../../models/group';
import {BijbEvent} from '../../../models/bijb-event';
import {ModuleSubscription} from '../../../models/module-subscription';

export class UpdateModuleSubscriptionAction implements Action {
  public static readonly type = 'UpdateModuleSubscriptionAction';

  constructor(public bijbEvent: BijbEvent, public moduleSubscription: ModuleSubscription) {
  }

  public type = UpdateModuleSubscriptionAction.type;
}
